import React from 'react';
import { tt } from '@i18n/tt';
import { useNavigate } from 'react-router-dom';
import { Button, Grid, Typography } from '@mui/material';

import { TICKET, TICKETS } from 'router/routes';

import Loader from 'components/Loader';

import useStyles from '../styles';
import EllipsisTooltip from '../../../components/EllipsisTooltip';
import CustomTypography from '../../../components/CustomTypography';
import { useTicketsFilters } from '../../Tickets/components/TicketsFilters/useTicketsFilters';
import StatusChip from '../../../components/StatusChip';
import TicketsSearch from '../../Tickets/components/TicketsSearch/TicketsSearch';

const UserTickets: React.FC = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  const { tickets, loading } = useTicketsFilters();

  return (
    <div className={classes.ticketsContainer}>
      <div className={classes.title}>
        <CustomTypography isDarkTextColor fontSize="20px" fontWeight={700}>
          {tt('pages.home.tickets.title')}
        </CustomTypography>
        <Button
          variant="contained"
          type="button"
          onClick={() => {
            navigate(TICKETS);
          }}
          className={classes.seeAll}
        >
          {tt('pages.home.tickets.titleButton')}
        </Button>
      </div>
      <TicketsSearch
        isCreateButtonDisplay={false}
        searchFieldClassName={classes.searchFieldClassName}
      />
      {loading && <Loader />}
      {!!tickets.length && !loading && (
        <div className={classes.tickets}>
          {tickets.map(ticket => (
            <div
              key={ticket.id}
              className={classes.ticket}
              onClick={() => {
                navigate(TICKET.replace(':ticketId', ticket.id));
              }}
            >
              <div className={classes.ticketTitle}>
                <EllipsisTooltip
                  className={classes.titleWrapper}
                  text={ticket.title}
                  typographyProps={{ isDarkTextColor: true, fontWeight: 700, fontSize: '16px' }}
                />
                <StatusChip text={ticket.status} status={ticket.status} />
              </div>
              <Grid container gap={1} marginTop={0.5}>
                <div>
                  <CustomTypography isDarkTextColor component="span" fontSize={12} fontWeight={500}>
                    Ticket number:
                  </CustomTypography>{' '}
                  <CustomTypography
                    darkModeColor="#cfcfcf"
                    component="span"
                    fontSize={12}
                    color="#6e6e6e"
                  >
                    {ticket.ticketNumber ?? ticket.id}
                  </CustomTypography>
                </div>
                <div>
                  <CustomTypography isDarkTextColor component="span" fontSize={12} fontWeight={500}>
                    Assigned To:
                  </CustomTypography>{' '}
                  <CustomTypography
                    darkModeColor="#cfcfcf"
                    component="span"
                    fontSize={12}
                    color="#6e6e6e"
                  >
                    {ticket.contactName || ticket.contact}
                  </CustomTypography>
                </div>
              </Grid>
            </div>
          ))}
        </div>
      )}
      {!loading && !tickets.length && (
        <Typography variant="h3" margin="auto">
          No tickets found
        </Typography>
      )}
    </div>
  );
};

export default UserTickets;
